module.exports = __webpack_public_path__ + "img/xy2@2x.a8c69d0e.png";